import { __assign, __rest } from "tslib";
import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import { useFunctionalRef } from '@wix/da-hooks/pkg/useFunctionalRef';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import LazyLoadingImage from '../../LazyLoadingImage';
import AvatarPlaceholder from '../AvatarPlaceholder';
import s from './AvatarImage.scss';
var MAX_PIXELATED_RESOLUTION = 50;
function isSmallGifImage(img) {
    if (!img.src) {
        return false;
    }
    var imgExtension = img.src.split('?').shift();
    if (!imgExtension) {
        return false;
    }
    imgExtension = imgExtension.split('.').pop();
    return (imgExtension === 'gif' &&
        img.naturalHeight <= MAX_PIXELATED_RESOLUTION &&
        img.naturalWidth <= MAX_PIXELATED_RESOLUTION);
}
var AvatarImage = function (_a) {
    var enableLazyLoad = _a.enableLazyLoad, imgProps = __rest(_a, ["enableLazyLoad"]);
    var _b = useState(false), shouldBePixelated = _b[0], setPixelated = _b[1];
    var _c = useFunctionalRef(null), imgRef = _c[0], setRef = _c[1];
    var onLoad = useCallback(function () {
        if (imgRef.current && isSmallGifImage(imgRef.current)) {
            setPixelated(true);
        }
    }, [imgRef]);
    var props = __assign(__assign({}, imgProps), { className: classnames(s['user-avatar'], shouldBePixelated && s['pixelated'], imgProps.className), onLoad: onLoad });
    if (!imgProps.src) {
        return (React.createElement(AvatarPlaceholder, { width: imgProps.width, height: imgProps.height, className: imgProps.className, "aria-hidden": imgProps['aria-hidden'] }));
    }
    if (!enableLazyLoad) {
        // eslint-disable-next-line jsx-a11y/alt-text
        return React.createElement("img", __assign({ loading: "lazy", "data-hook": BiDataHook.USER_AVATAR }, props));
    }
    return (React.createElement(LazyLoadingImage, __assign({ "data-hook": BiDataHook.USER_AVATAR, innerRef: setRef }, props)));
};
AvatarImage.displayName = 'AvatarImage';
export default AvatarImage;
//# sourceMappingURL=AvatarImage.js.map